import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch, useRouteMatch } from 'react-router-dom';
import { AdminGroupsCreatePage } from './create/AdminGroupsCreatePage';
import { AdminGroupsEditPage } from './edit/AdminGroupsEditPage';
import { AdminGroupsListPage } from './list/AdminGroupsListPage';
import { ViewGroupPage } from './view/ViewGroupPage';

export function AdminGroupsRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/add`} component={AdminGroupsCreatePage} />
      <AppRoute path={`${path}/:id/edit`} component={AdminGroupsEditPage} />
      <AppRoute path={`${path}/:id`} component={ViewGroupPage} />
      <AppRoute path={path} component={AdminGroupsListPage} />
    </Switch>
  );
}
